import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addCompanyReview, fetchPublicCompanyReviews } from "./PublicCompanyReviewsAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchPublicCompanyReviewsAsync = createAsyncThunk(
  "PublicCompanyReviews/fetch",
  async ({uuid}, { rejectWithValue }) => {
    try {
      const data = await fetchPublicCompanyReviews(uuid);

      const resp = data.response.data;
      // console.log("data's response", data.response.data)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// candidate side
export const addCompanyReviewAsync = createAsyncThunk(
  "CompanyReviews/add",
  async (newCompanyReview) => {
    try {
      const data = await addCompanyReview(newCompanyReview);
      console.log("data in slice", data);
      return data;
    } catch (error) {
      console.log("errorL :", error);
      // return rejectWithValue(error.message);
    }
  }
);

const PublicCompanyReviewsSlice = createSlice({
  name: "PublicCompanyReviews",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicCompanyReviewsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicCompanyReviewsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchPublicCompanyReviewsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      
      .addCase(addCompanyReviewAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(addCompanyReviewAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add CompanyReview";
      })
  },
});

export const selectPublicCompanyReviews = (state) => state.publicCompanyReviews.data;

export default PublicCompanyReviewsSlice.reducer;
